<template>
  <div class="to-view-patient-files">
    <form id="app" class="phone-form card-doc-upload" data-parsley-validate>
      <md-card>
        <md-card-area md-inset>
          <md-card-header>
            <span>
              {{ $t("message.accessInstructions1") }}
              <br />
              {{ $t("message.accessInstructions2") }}
            </span>
            <br />
            <div class="text-card">{{ $t("message.mandatoryField") }}</div>
            <div class="md-title title-style">
              {{ $t("message.insertPhoneNumber") }}
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout md-gutter">
              <div
                class="
                  md-layout-item
                  md-xsmall-size-100
                  md-small-size-100
                  md-medium-size-25
                  md-large-size-25
                  md-xlarge-size-25
                "
              >
                <md-field>
                  <label for="patientPhPrefix">{{
                    $t("message.phonePrefix")
                  }}</label>
                  <md-select
                    v-model="patientPhPrefix"
                    name="patientPhPrefix"
                    id="patientPhPrefix"
                  >
                    <!--<md-option value="fight-club"><span><span class="color" :style="`background-color: #ffa500`"></span>Fight Club</span></md-option>-->
                    <template v-for="country in countries">
                      <md-option
                        v-bind:key="country.index"
                        :value="`${country.index}`"
                        >{{ country.text }}</md-option
                      >
                    </template>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item">
                <md-field :class="messageClass" md-clearable>
                  <label v-if="!isIE" for="patientPhNo">{{
                    $t("message.phoneNumber")
                  }}</label>

                  <label v-if="isIE" for="patientPhNo"
                    >{{ $t("message.phoneNumber") }}&nbsp;</label
                  >
                  <md-input
                    v-model="patientPhNo"
                    name="patientPhNo"
                    type="text"
                    id="patientPhNo"
                    value="patientPhNo"
                    required
                    md-counter="10"
                    data-parsley-type="digits"
                    data-parsley-errors-messages-disabled="true"
                  ></md-input>
                  <span class="md-error" v-if="patientPhNoIsEmpty">{{
                    $t("message.complCampo")
                  }}</span>
                </md-field>
              </div>
            </div>
          </md-card-content>
        </md-card-area>

        <md-card-content class="privacy-card">
          <md-checkbox v-model="privacy"
            >{{ $t("message.iHaveRead")
            }}<a @click.prevent="informativa($event)">{{
              $t("message.termsAndConditions")
            }}</a>
          </md-checkbox>
        </md-card-content>

        <br />
        <md-card-actions class="button-card">
          <md-button
            class="md-raised md-accent submit-button"
            :md-ripple="false"
            type="submit"
            @click="validateRegistration($event)"
            :disabled="privacy == false"
            value="Submit"
            >{{ $t("message.confirm") }}</md-button
          >
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import firebase from "firebase/app";

import $ from "jquery";
import axios from "axios";

import "firebase/auth";
import languagePicker from "@/components/language-picker/LanguagePicker.vue";

export default {
  name: "to-view-patient-files",
  data() {
    return {
      isIE: false,
      submitForm: {},
      patientPhPrefix: "109",
      patientPhNo: null,
      patientPhNoIsEmpty: false,
      privacy: false,
      countries: [
        { index: 1, text: "+93", value: "+93" },
        { index: 2, text: "+355", value: "+355" },
        { index: 3, text: "+213", value: "+213" },
        { index: 4, text: "+376", value: "+376" },
        { index: 5, text: "+244", value: "+244" },
        { index: 6, text: "+1", value: "+1" },
        { index: 7, text: "+1", value: "+1" },
        { index: 8, text: "+599", value: "+599" },
        { index: 9, text: "+966", value: "+966" },
        { index: 10, text: "+54", value: "+54" },
        { index: 11, text: "+374", value: "+374" },
        { index: 12, text: "+297", value: "+297" },
        { index: 13, text: "+247", value: "+247" },
        { index: 14, text: "+61", value: "+61" },
        { index: 15, text: "+43", value: "+43" },
        { index: 16, text: "+994", value: "+994" },
        { index: 17, text: "+1", value: "+1" },
        { index: 18, text: "+973", value: "+973" },
        { index: 19, text: "+880", value: "+880" },
        { index: 20, text: "+1", value: "+1" },
        { index: 21, text: "+32", value: "+32" },
        { index: 22, text: "+501", value: "+501" },
        { index: 23, text: "+229", value: "+229" },
        { index: 24, text: "+1", value: "+1" },
        { index: 25, text: "+975", value: "+975" },
        { index: 26, text: "+375", value: "+375" },
        { index: 27, text: "+591", value: "+591" },
        { index: 28, text: "+387", value: "+387" },
        { index: 29, text: "+267", value: "+267" },
        { index: 30, text: "+55", value: "+55" },
        { index: 31, text: "+673", value: "+673" },
        { index: 32, text: "+359", value: "+359" },
        { index: 33, text: "+226", value: "+226" },
        { index: 34, text: "+257", value: "+257" },
        { index: 35, text: "+855", value: "+855" },
        { index: 36, text: "+237", value: "+237" },
        { index: 37, text: "+1", value: "+1" },
        { index: 38, text: "+238", value: "+238" },
        { index: 39, text: "+235", value: "+235" },
        { index: 40, text: "+56", value: "+56" },
        { index: 41, text: "+86", value: "+86" },
        { index: 42, text: "+357", value: "+357" },
        { index: 43, text: "+39", value: "+39" },
        { index: 44, text: "+57", value: "+57" },
        { index: 45, text: "+269", value: "+269" },
        { index: 46, text: "+242", value: "+242" },
        { index: 47, text: "+850", value: "+850" },
        { index: 48, text: "+82", value: "+82" },
        { index: 49, text: "+225", value: "+225" },
        { index: 50, text: "+506", value: "+506" },
        { index: 51, text: "+385", value: "+385" },
        { index: 52, text: "+53", value: "+53" },
        { index: 53, text: "+599", value: "+599" },
        { index: 54, text: "+45", value: "+45" },
        { index: 55, text: "+1", value: "+1" },
        { index: 56, text: "+593", value: "+593" },
        { index: 57, text: "+20", value: "+20" },
        { index: 58, text: "+503", value: "+503" },
        { index: 59, text: "+971", value: "+971" },
        { index: 60, text: "+291", value: "+291" },
        { index: 61, text: "+372", value: "+372" },
        { index: 62, text: "+268", value: "+268" },
        { index: 63, text: "+251", value: "+251" },
        { index: 64, text: "+679", value: "+679" },
        { index: 65, text: "+63", value: "+63" },
        { index: 66, text: "+358", value: "+358" },
        { index: 67, text: "+33", value: "+33" },
        { index: 68, text: "+241", value: "+241" },
        { index: 69, text: "+220", value: "+220" },
        { index: 70, text: "+995", value: "+995" },
        { index: 71, text: "+49", value: "+49" },
        { index: 72, text: "+233", value: "+233" },
        { index: 73, text: "+1", value: "+1" },
        { index: 74, text: "+81", value: "+81" },
        { index: 75, text: "+350", value: "+350" },
        { index: 76, text: "+253", value: "+253" },
        { index: 77, text: "+962", value: "+962" },
        { index: 78, text: "+30", value: "+30" },
        { index: 79, text: "+1", value: "+1" },
        { index: 80, text: "+299", value: "+299" },
        { index: 81, text: "+590", value: "+590" },
        { index: 82, text: "+1", value: "+1" },
        { index: 83, text: "+502", value: "+502" },
        { index: 84, text: "+224", value: "+224" },
        { index: 85, text: "+245", value: "+245" },
        { index: 86, text: "+240", value: "+240" },
        { index: 87, text: "+592", value: "+592" },
        { index: 88, text: "+594", value: "+594" },
        { index: 89, text: "+509", value: "+509" },
        { index: 90, text: "+504", value: "+504" },
        { index: 91, text: "+852", value: "+852" },
        { index: 92, text: "+91", value: "+91" },
        { index: 93, text: "+62", value: "+62" },
        { index: 94, text: "+98", value: "+98" },
        { index: 95, text: "+964", value: "+964" },
        { index: 96, text: "+353", value: "+353" },
        { index: 97, text: "+354", value: "+354" },
        { index: 98, text: "+1", value: "+1" },
        { index: 99, text: "+682", value: "+682" },
        { index: 100, text: "+672", value: "+672" },
        { index: 101, text: "+500", value: "+500" },
        { index: 102, text: "+298", value: "+298" },
        { index: 103, text: "+1", value: "+1" },
        { index: 104, text: "+692", value: "+692" },
        { index: 105, text: "+677", value: "+677" },
        { index: 106, text: "+1284", value: "+1284" },
        { index: 107, text: "+1", value: "+1" },
        { index: 108, text: "+972", value: "+972" },
        { index: 109, text: "+39", value: "+39" },
        { index: 110, text: "+7", value: "+7" },
        { index: 111, text: "+254", value: "+254" },
        { index: 112, text: "+996", value: "+996" },
        { index: 113, text: "+686", value: "+686" },
        { index: 114, text: "+383", value: "+383" },
        { index: 115, text: "+965", value: "+965" },
        { index: 116, text: "+856", value: "+856" },
        { index: 117, text: "+266", value: "+266" },
        { index: 118, text: "+371", value: "+371" },
        { index: 119, text: "+961", value: "+961" },
        { index: 120, text: "+231", value: "+231" },
        { index: 121, text: "+218", value: "+218" },
        { index: 122, text: "+423", value: "+423" },
        { index: 123, text: "+370", value: "+370" },
        { index: 124, text: "+352", value: "+352" },
        { index: 125, text: "+853", value: "+853" },
        { index: 126, text: "+389", value: "+389" },
        { index: 127, text: "+261", value: "+261" },
        { index: 128, text: "+265", value: "+265" },
        { index: 129, text: "+960", value: "+960" },
        { index: 130, text: "+60", value: "+60" },
        { index: 131, text: "+223", value: "+223" },
        { index: 132, text: "+356", value: "+356" },
        { index: 133, text: "+212", value: "+212" },
        { index: 134, text: "+596", value: "+596" },
        { index: 135, text: "+222", value: "+222" },
        { index: 136, text: "+230", value: "+230" },
        { index: 137, text: "+52", value: "+52" },
        { index: 138, text: "+691", value: "+691" },
        { index: 139, text: "+373", value: "+373" },
        { index: 140, text: "+976", value: "+976" },
        { index: 141, text: "+382", value: "+382" },
        { index: 142, text: "+1", value: "+1" },
        { index: 143, text: "+258", value: "+258" },
        { index: 144, text: "+95", value: "+95" },
        { index: 145, text: "+264", value: "+264" },
        { index: 146, text: "+674", value: "+674" },
        { index: 147, text: "+977", value: "+977" },
        { index: 148, text: "+505", value: "+505" },
        { index: 149, text: "+227", value: "+227" },
        { index: 150, text: "+234", value: "+234" },
        { index: 151, text: "+683", value: "+683" },
        { index: 152, text: "+47", value: "+47" },
        { index: 153, text: "+687", value: "+687" },
        { index: 154, text: "+64", value: "+64" },
        { index: 155, text: "+968", value: "+968" },
        { index: 156, text: "+31", value: "+31" },
        { index: 157, text: "+92", value: "+92" },
        { index: 158, text: "+680", value: "+680" },
        { index: 159, text: "+507", value: "+507" },
        { index: 160, text: "+675", value: "+675" },
        { index: 161, text: "+595", value: "+595" },
        { index: 162, text: "+51", value: "+51" },
        { index: 163, text: "+689", value: "+689" },
        { index: 164, text: "+48", value: "+48" },
        { index: 165, text: "+351", value: "+351" },
        { index: 166, text: "+1", value: "+1" },
        { index: 167, text: "+377", value: "+377" },
        { index: 168, text: "+974", value: "+974" },
        { index: 169, text: "+44", value: "+44" },
        { index: 170, text: "+420", value: "+420" },
        { index: 171, text: "+236", value: "+236" },
        { index: 172, text: "+243", value: "+243" },
        { index: 173, text: "+1", value: "+1" },
        { index: 174, text: "+262", value: "+262" },
        { index: 175, text: "+40", value: "+40" },
        { index: 176, text: "+250", value: "+250" },
        { index: 177, text: "+7", value: "+7" },
        { index: 178, text: "+590", value: "+590" },
        { index: 179, text: "+290", value: "+290" },
        { index: 180, text: "+1", value: "+1" },
        { index: 181, text: "+590", value: "+590" },
        { index: 182, text: "+508", value: "+508" },
        { index: 183, text: "+1", value: "+1" },
        { index: 184, text: "+685", value: "+685" },
        { index: 185, text: "+1", value: "+1" },
        { index: 186, text: "+378", value: "+378" },
        { index: 187, text: "+1", value: "+1" },
        { index: 188, text: "+239", value: "+239" },
        { index: 189, text: "+221", value: "+221" },
        { index: 190, text: "+381", value: "+381" },
        { index: 191, text: "+248", value: "+248" },
        { index: 192, text: "+232", value: "+232" },
        { index: 193, text: "+65", value: "+65" },
        { index: 194, text: "+1", value: "+1" },
        { index: 195, text: "+963", value: "+963" },
        { index: 196, text: "+421", value: "+421" },
        { index: 197, text: "+386", value: "+386" },
        { index: 198, text: "+252", value: "+252" },
        { index: 199, text: "+34", value: "+34" },
        { index: 200, text: "+94", value: "+94" },
        { index: 201, text: "+27", value: "+27" },
        { index: 202, text: "+249", value: "+249" },
        { index: 203, text: "+211", value: "+211" },
        { index: 204, text: "+597", value: "+597" },
        { index: 205, text: "+46", value: "+46" },
        { index: 206, text: "+41", value: "+41" },
        { index: 207, text: "+992", value: "+992" },
        { index: 208, text: "+886", value: "+886" },
        { index: 209, text: "+66", value: "+66" },
        { index: 210, text: "+255", value: "+255" },
        { index: 211, text: "+670", value: "+670" },
        { index: 212, text: "+228", value: "+228" },
        { index: 213, text: "+690", value: "+690" },
        { index: 214, text: "+676", value: "+676" },
        { index: 215, text: "+1", value: "+1" },
        { index: 216, text: "+216", value: "+216" },
        { index: 217, text: "+90", value: "+90" },
        { index: 218, text: "+993", value: "+993" },
        { index: 219, text: "+1", value: "+1" },
        { index: 220, text: "+688", value: "+688" },
        { index: 221, text: "+380", value: "+380" },
        { index: 222, text: "+256", value: "+256" },
        { index: 223, text: "+36", value: "+36" },
        { index: 224, text: "+598", value: "+598" },
        { index: 225, text: "+1", value: "+1" },
        { index: 226, text: "+998", value: "+998" },
        { index: 227, text: "+678", value: "+678" },
        { index: 228, text: "+58", value: "+58" },
        { index: 229, text: "+84", value: "+84" },
        { index: 230, text: "+681", value: "+681" },
        { index: 231, text: "+967", value: "+967" },
        { index: 232, text: "+260", value: "+260" },
        { index: 233, text: "+263", value: "+263" }
      ]
    };
  },
  computed: {
    messageClass() {
      if (!this.patientPhNo) {
        return {
          "md-invalid": this.patientPhNoIsEmpty
        };
      }
    }
  },
  mounted: function() {
    var self = this;
    var ua = window.navigator.userAgent;
    self.isIE = /MSIE|Trident/.test(ua);
    //console.log("inserisci il numero di telefono");
    var user = firebase.auth().currentUser;
    if (user) {
      firebase.auth().signOut();
    }
    this.submitForm = $(".phone-form");
    this.setTrigger();
  },
  methods: {
    informativa: function(event) {
      this.privacy = !this.privacy;
      event.preventDefault();

      var self = this;
      var link = "";
      switch (self.$i18n.locale) {
        case "it":
          link =
            "https://www.humanitas.it/wp-content/uploads/policy/Informativa_piattaforma_Comunicazione_Sicura.pdf";
          break;
        case "en":
          link =
            "https://www.humanitas.it/wp-content/uploads/policy/Informativa_piattaforma_Comunicazione_Sicura_ENG.pdf";
          break;
      }
      window.open(
        link,
        "_blank",
        "location=yes,height=570,width=520,scrollbars=yes,status=yes"
      );
    },
    validatePhoneNumber: function(phoneNumber) {
      var re = /^\+[0-9]*$/;
      return re.test(String(phoneNumber));
    },
    showInvalidPhoneNumberMessage: function() {
      var self = this;
      self.$notify({
        group: "foo",
        title: self.$t("message.invalidPhNum"),
        text: self.$t("message.invPhNumMsg"),
        duration: 300
      });
    },
    getUserInfo: function(number, prefix) {
      var self = this;
      axios
        .post(
          "/api/getUserInfo",
          {
            userPhone: number
          },
          {
            headers: {
              //Authorization: 'Bearer ' + idToken
            }
          }
        )
        .then(function(data) {
          //console.log("SUCCESS");
          //console.log(data);
          if (data.data.data) {
            self.$store.commit("prefix", prefix);
            self.$store.commit("userFlux", self.$route.fullPath);
            self.$router.push({ path: "/download-files" });
          } else {
            self.showInvalidPhoneNumberMessage();
          }
        })
        .catch(function(e) {
          //console.log("User Info retrieving failed because: ", e);
          //console.log("user not in db");
        });
    },
    setTrigger() {
      var self = this;
      //console.log("set trigger");
      self.submitForm.parsley().on("form:success", function() {
        //console.info("OK");
        self.submitRegistration();
      });
      self.submitForm.parsley().on("form:error", function() {
        //console.error("Invalid Number");
        //TODO PUT MESSAGES
        // self.invalidEmail = true
        // $('#add-admin-email').blur()
        // self.addAdminValidationError()
      });
    },
    validateRegistration: function(event) {
      event.preventDefault();
      var self = this;
      self.submitForm.parsley().validate();
    },
    submitRegistration: function() {
      var self = this;
      var prefix = "+39";
      for (var i = 0; i < self.countries.length; i++) {
        var country = self.countries[i];
        if (country.index == self.patientPhPrefix) {
          prefix = country.value;
          break;
        }
      }
      var number = prefix + self.patientPhNo;
      if (!self.validatePhoneNumber(number)) {
        self.showInvalidPhoneNumberMessage();
      } else {
        self.$store.commit("userPhone", number);
        self.getUserInfo(number, prefix);
      }
    }
  },
  components: {
    languagePicker
  }
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */
.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.privacy-card {
  text-align: left;
  padding-bottom: 0;
}
.button-card {
  padding-top: 0;
}

.md-card-actions .md-button:last-child {
  margin-right: 9px;
  margin-bottom: 9px;
}

.md-card {
  width: 60%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

@media only screen and (max-width: 600px) {
  .md-card {
    width: 80%;
  }
}

.logo {
  margin-top: 60px;
  width: 10%;
  height: 10%;
}

.title-style {
  color: #027953;
  font-size: 20px;
}

.text-style {
  color: #027953;
  font-size: 15px;
  text-align: center;
  padding-top: 1%;
}

.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.logout {
  margin-top: 40px;
}

.home-button {
  width: 487px;
}

.nav-style {
  height: 50px;
}

.second-navbar {
  background-color: #027953;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
  padding: 1.3%;
}

.text-card {
  text-align: right;
  color: grey;
}

.first-nav {
  background-color: #ffffff !important;
}

.simple-text {
  color: black;
  font-size: 17px;
}

.button-text {
  padding-top: 6%;
  padding-left: 1%;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/ToViewPatientFiles.vue